import { OptionFilter } from '.';
import React, { memo, useMemo } from 'react';
import { useTags } from '@hooks';
export const TagFilter = memo(({ onChange }) => {
    const tags = useTags();
    const sortedTags = useMemo(() => tags.map((tag) => ({
        label: tag.name,
        value: tag.id
    })), [tags]);
    return (React.createElement(OptionFilter, { onChange: (filterByTags) => onChange({ filterByTags: filterByTags }), options: sortedTags, placeholder: 'Filter by Tag' }));
});
